import { render, staticRenderFns } from "./sbj-input.vue?vue&type=template&id=441e263c&"
import script from "./sbj-input.vue?vue&type=script&lang=js&"
export * from "./sbj-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports